import posthog from 'posthog-js';
import * as Sentry from '@sentry/browser';
import _get from 'lodash/get';
import _isString from 'lodash/isString';

import { logError } from 'utils';
import { preventErrorLog } from 'utils/methods';
import localStore from '../localStore.js';
import { STORAGE_KEYS } from 'utils/DICTIONARY.js';

export default function identifyUser() {
  const posthogApp = process.env.REACT_APP_POSTHOG_KEY;
  const sentryApp = process.env.REACT_APP_SENTRY_APP_ID;

  try {
    const userData = localStore.get(STORAGE_KEYS.USER_DATA);
    const store = localStore.get(STORAGE_KEYS.LOGGED_IN_STORE_NAME);

    if (!userData || !_isString(userData) || preventErrorLog()) {
      return;
    }

    const user = JSON.parse(userData);
    const userId = _get(user, 'userId', '');
    const email = _get(user, 'email', '');
    const firstName = _get(user, 'firstName', '');
    const lastName = _get(user, 'lastName', '');
    const name = `${firstName} ${lastName}`;

    if (!userId) {
      return;
    }

    if (posthogApp) {
      posthog.identify(userId, { name, email, store });
      posthog.group('store', store);
    }

    if (sentryApp) {
      Sentry.configureScope(scope => {
        scope.setUser({ id: userId, email, username: name });
      });
    }
  } catch (e) {
    logError(e);
  }
}
